import React from 'react';
import PropTypes from 'prop-types';
import CheckoutModal from './single_page_checkout/modal';
import Collection from './single_page_checkout/collection';
import DeliveryDetails from './single_page_checkout/delivery_details';
import Payment from './single_page_checkout/payment';
import DeliveryAddress from './single_page_checkout/delivery_address';
import GenericError from './single_page_checkout/generic_error';
import OrderComplete from './single_page_checkout/order_complete';
import OrderSummary from './single_page_checkout/order_summary';

class Checkout extends React.Component {
  // TODO:
  // ====
  // 1. Extract Error Modal into own component
  // 2. Remove Lodash

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      lading_message: '',
      processing_order: false,
      order_summary: {
        total: 'loading',
      },
      steps: [
        'DELIVERY_ADDRESS',
        'DELIVERY_DETAILS',
        'COLLECTION_DETAILS',
        'PAYMENT',
        'COMPLETE',
      ],
      current_step:
        this.props.basket_summary.type === 'COLLECTION'
          ? 'COLLECTION_DETAILS'
          : 'DELIVERY_ADDRESS',
      paymentOpen: false,
      progress: 'start',
      processing_payment: false,
      order_complete: false,
      order_complete_url: '',
      order_complete_summary: '',
      basket_summary: this.props.basket_summary,
      address_mode: this.props.address_mode,
      selected_delivery_address: {
        name: this.props.basket_summary.delivery_address.delivery_name,
        line1: this.props.basket_summary.delivery_address.delivery_address1,
        line2: this.props.basket_summary.delivery_address.delivery_address2,
        line3: this.props.basket_summary.delivery_address.delivery_address3,
        line4: this.props.basket_summary.delivery_address.delivery_address4,
        line5: this.props.basket_summary.delivery_address.delivery_address5,
        postcode: this.props.basket_summary.delivery_address.delivery_postcode,
      },

      selected_billing_address: {
        name: this.props.basket_summary.delivery_address.delivery_name,
        line1: this.props.basket_summary.delivery_address.delivery_address1,
        line2: this.props.basket_summary.delivery_address.delivery_address2,
        line3: this.props.basket_summary.delivery_address.delivery_address3,
        line4: this.props.basket_summary.delivery_address.delivery_address4,
        line5: this.props.basket_summary.delivery_address.delivery_address5,
        postcode: this.props.basket_summary.delivery_address.delivery_postcode,
      },
      collection_address: this.props.basket_summary.collection_address,
      collection_information: {},
      address_book: this.props.address_book,
      guestTelephone: '',
      accountTelephone: this.props.account_details.telephone,
      branches: [],
      showNoBranches: false,
      showBranchPanel: false,
      delivery_options: this.props.delivery_options,
      generic_error: {
        active: false,
        title: '',
        body: '',
        errorButton: false,
        errorButtonTitle: '',
        errorButtonAction: null,
        contactButtn: true,
        contactUrl: this.props.urls.contact_us,
        reloadCheckoutAfterClose: false,
        reloadCheckoutAfterErrorButtonAction: false,
        checkoutUrl: this.props.urls.checkout_url,
        closeAction: this.toggleGenericError,
      },
      show_display_error: false,
      display_errors: [],
      branchAddressFlag: false,
      basketHasBackOrderItems:
        this.props.basket_summary.basket_has_back_order_items,
      paymentOptions: this.props.payment_options_statuses || {},
      messaging: this.props.messaging,
    };

    this.clearDeliveryService = this.clearDeliveryService.bind(this);
    this.completeCollectionOnlyOrder =
      this.completeCollectionOnlyOrder.bind(this);
    this.completeOrder = this.completeOrder.bind(this);
    this.configGenericError = this.configGenericError.bind(this);
    this.getAddressBook = this.getAddressBook.bind(this);
    this.getBranches = this.getBranches.bind(this);
    this.getBasketSummary = this.getBasketSummary.bind(this);
    this.getDeliveryOptionsForBasket =
      this.getDeliveryOptionsForBasket.bind(this);
    this.getUrlParameter = this.getUrlParameter.bind(this);
    this.handleUrlParams = this.handleUrlParams.bind(this);
    this.removeLoader = this.removeLoader.bind(this);
    this.scrollToStep = this.scrollToStep.bind(this);
    this.setAddressFromAddressBook = this.setAddressFromAddressBook.bind(this);
    this.setInvoiceAddressFromAddressBook =
      this.setInvoiceAddressFromAddressBook.bind(this);
    this.setAddressMode = this.setAddressMode.bind(this);
    this.setCurrentStep = this.setCurrentStep.bind(this);
    this.setDeliveryAddress = this.setDeliveryAddress.bind(this);
    this.setInvoiceAddress = this.setInvoiceAddress.bind(this);
    this.setInvoiceAddressAsDeliveryAddress =
      this.setInvoiceAddressAsDeliveryAddress.bind(this);
    this.setLoadingState = this.setLoadingState.bind(this);
    this.setProcessingPayment = this.setProcessingPayment.bind(this);
    this.setProgress = this.setProgress.bind(this);
    this.toggleGenericError = this.toggleGenericError.bind(this);
    this.setGuestTelephone = this.setGuestTelephone.bind(this);
    this.showDetailErrors = this.showDetailErrors.bind(this);
    this.setBranchAddressFlag = this.setBranchAddressFlag.bind(this);
    this.pushDataLayer = this.pushDataLayer.bind(this);
  }

  componentWillMount() {
    this.handleUrlParams();
  }

  setBranchAddressFlag(flag) {
    if (!this.state.signed_in) {
      this.setState({ branchAddressFlag: flag });
    }
  }

  toggleGenericError() {
    const cge = this.state.generic_error;
    cge.active = !cge.active;
    this.setState({
      generic_error: cge,
    });
  }

  configGenericError(config) {
    let generic_error = this.state.generic_error;
    let params = Object.keys(config);
    params.forEach(key => {
      generic_error[key] = config[key];
    });

    this.setState(
      {
        generic_error,
      },
      () => {
        this.toggleGenericError();
      },
    );
  }

  pushDataLayer(currentStep) {
    const { lines } = this.state.basket_summary;

    dataLayer.push({
      event: 'checkoutStep',
      ecommerce: {
        currencyCode: 'GBP',
        checkout: {
          actionField: { step: currentStep },
          products: lines.map(
            ({ brand, category, description, id, goods, stepId }) => ({
              id,
              brand,
              'id-variant': stepId,
              name: description,
              category,
              price: parseFloat(goods),
              quantity: 1,
            }),
          ),
        },
      },
    });
  }

  componentDidMount() {
    this.removeLoader();
    if (this.props.signed_in)
      this.setInvoiceAddress(this.state.selected_billing_address);
    if (!this.props.signed_in) this.setAddressMode('GUEST_NEW_ADDRESS');

    this.pushDataLayer(1);
  }

  setProcessingPayment(state) {
    this.setState({ processing_payment: state });
  }
  removeLoader() {
    let loader = document.querySelector('.checkout--loader');

    setTimeout(() => {
      loader.classList.add('loaded');
      setTimeout(() => {
        loader.parentNode.removeChild(loader);
      }, 300);
    }, 1000);
  }
  setLoadingState(state) {
    this.setState({
      loading: state,
    });
  }
  handleUrlParams() {
    switch (this.getUrlParameter('error')) {
      case 'paypal-payment-cancelled':
        this.configGenericError({
          title: 'PayPal Payment Error',
          body: (
            <div>
              <p>Unfortunately your payment was not successful.</p>
              <p>No payment has been taken from your Paypal Account.</p>
              <p>
                We are sorry for any inconvenience this may cause. Please try
                again later. If the problem persists, please contact our
                customer service team.
              </p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: 'Continue Checkout',
          errorButtonAction: this.toggleGenericError,
          closeAction: this.toggleGenericError,
          reloadCheckoutAfterClose: false,
          reloadCheckoutAfterErrorButtonAction: false,
        });
        break;
    }
  }
  getAddressBook() {
    $.ajax({
      url: this.props.urls.delivery_address,
      dataType: 'json',
      success: addresses => {
        this.setState({ address_book: addresses });
      },
      error: () => {
        this.configGenericError({
          title: 'Address Book Error',
          body: (
            <div>
              <p>We've been unable to get your Address Book.</p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: 'Reload Address Book',
          errorButtonAction: this.getAddressBook,
          reloadCheckoutAfterClose: false,
          reloadCheckoutAfterErrorButtonAction: false,
        });
      },
    });
  }
  getBranches(postcode, locationSearch) {
    $.ajax({
      url: this.props.urls.store_finders,
      dataType: 'json',
      data: {
        q: postcode,
      },
      success: branches => {
        if (branches.stores.length > 0) {
          var nameChangedBranches = [];

          for (let index = 0; index < branches.stores.length; index++) {
            var store = branches.stores[index];
            store.name = store.name.replace('Branch', 'Store');
            nameChangedBranches.push(store);
          }

          this.setState({
            branches: nameChangedBranches,
            showBranchPanel: true,
            showNoBranches: false,
          });
        } else {
          this.setState({
            branches: [],
            showNoBranches: true,
            showBranchPanel: true,
          });
        }
      },
      error: () => {
        this.configGenericError({
          title: 'Store Search Error',
          body: (
            <div>
              <p>We've been unable to locate your nearest stores.</p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: 'Close',
          errorButtonAction: this.toggleGenericError,
          closeAction: this.toggleGenericError,
          reloadCheckoutAfterClose: false,
          reloadCheckoutAfterErrorButtonAction: false,
        });
      },
    });
  }
  getDeliveryOptionsForBasket() {
    $.ajax({
      url: this.props.urls.delivery_options,
      dataType: 'json',
      success: data => {
        this.setState({
          delivery_options: data,
        });
        setTimeout(() => {
          this.setState(
            { loading: false, loading_message: '' },
            this.setCurrentStep('DELIVERY_DETAILS'),
          );
        }, 100);
      },
      error: () => {
        // TODO: Error handling
        console.log('Error getting delivery options');
      },
    });
  }
  getBasketSummary() {
    $.ajax({
      url: this.props.urls.order_summary,
      dataType: 'json',
      success: data => {
        this.setState({ loading: false });
        this.setState({
          basket_summary: data,
        });
      },
      error: () => {
        this.configGenericError({
          title: 'Error',
          body: (
            <div>
              <p>Unfortunately there has been an error.</p>
              <p>
                We are sorry for any inconvenience this may cause. Please try
                again later. If the problem persists, please contact our
                customer service team.
              </p>
            </div>
          ),
          errorButton: false,
          reloadCheckoutAfterClose: true,
          reloadCheckoutAfterErrorButtonAction: true,
        });
      },
    });
  }
  completeOrder(order) {
    this.setState({
      order_complete: true,
      order_complete_url: order.url,
    });
  }
  scrollToStep(element) {
    $('html, body').animate(
      {
        scrollTop: $(element).offset().top - 40,
      },
      1000,
    );
  }

  setProgress() {
    const {
      address_mode: addressMode,
      basket_summary: basketSummary,
      current_step: currentStep,
    } = this.state;

    switch (basketSummary.type) {
      case 'DELIVERY':
        if (currentStep === 'DELIVERY_ADDRESS') {
          this.setState({ progress: 'start', paymentOpen: false });
          this.scrollToStep('.delivery-address-step');
        }
        if (currentStep === 'DELIVERY_DETAILS') {
          this.pushDataLayer(2);
          this.setState({ progress: 'onethird', paymentOpen: false });
          this.scrollToStep('.delivery-details-step');
          dataLayer.push({
            event: 'deliveryAddress',
            option: addressMode,
          });
        }
        if (currentStep === 'PAYMENT') {
          this.pushDataLayer(3);
          this.scrollToStep('.payment-details-step');
          this.setState({ progress: 'twothirds', paymentOpen: true });
        }
        if (currentStep === 'COMPLETE') {
          this.setState({ progress: 'complete' });
        }
        break;
      case 'MIXED':
        if (currentStep === 'DELIVERY_ADDRESS') {
          this.setState({ progress: 'start', paymentOpen: false });
        }
        if (currentStep === 'DELIVERY_DETAILS') {
          this.pushDataLayer(2);
          this.setState({ progress: 'onequarter', paymentOpen: false });
          this.scrollToStep('.delivery-details-step');
        }
        if (currentStep === 'COLLECTION_DETAILS') {
          this.setState({ progress: 'half', paymentOpen: false });
          this.scrollToStep('.collection-details-step');
        }
        if (currentStep === 'PAYMENT') {
          this.pushDataLayer(3);
          this.setState({ progress: 'threequarters', paymentOpen: true });
          this.scrollToStep('.payment-details-step');
        }
        if (currentStep === 'COMPLETE') {
          this.setState({ progress: 'complete' });
        }
        break;
      case 'COLLECTION_DETAILS':
        this.setState({ progress: 'half' });
        if (currentStep === 'COMPLETE') {
          this.setState({ progress: 'complete' });
        }
        break;
    }
  }

  setCurrentStep(step) {
    this.setState({ current_step: step }, () => {
      this.setProgress();
    });
  }
  setGuestTelephone(tel) {
    this.setState({ guestTelephone: tel });
  }

  setAddressMode(mode) {
    this.setState({
      address_mode: mode,
    });
    if (mode === 'BRANCH_DELIVERY') this.setState({ showBranchPanel: true });
    if (mode === 'GUEST_NEW_ADDRESS') this.setState({ showBranchPanel: false });
  }

  clearDeliveryService() {
    this.setState({ branchAddressFlag: false });
    this.setLoadingState(true);
    $.ajax({
      url: this.props.urls.clear_delivery_details,
      method: 'POST',
      dataType: 'json',
      success: () => {
        this.getBasketSummary();
      },
      error: () => {
        // TODO: Error handling
      },
    });
  }

  setInvoiceAddressAsDeliveryAddress() {
    this.setDeliveryAddress({
      name: this.props.account_details.invoice_address.name,
      line1: this.props.account_details.invoice_address.line_1,
      line2: this.props.account_details.invoice_address.line_2,
      line3: this.props.account_details.invoice_address.line_3,
      line4: this.props.account_details.invoice_address.line_4,
      line5: this.props.account_details.invoice_address.line_5,
      postcode: this.props.account_details.invoice_address.postcode,
    });
  }

  setAddressFromAddressBook(address) {
    this.setDeliveryAddress(address);
  }
  setInvoiceAddressFromAddressBook(address) {
    this.setInvoiceAddress(address);
  }

  setDeliveryAddress(delivery_address) {
    this.setState({
      loading: true,
      loading_message: 'Setting your delivery address',
    });

    const guestName =
      this.state.address_mode === 'BRANCH_DELIVERY'
        ? delivery_address.name
        : this.props.misc.name;

    const deliveryAddressName = this.props.signed_in
      ? delivery_address.name
      : guestName;

    let formatted_address = delivery_address.hasOwnProperty('line_1')
      ? {
          delivery_name: deliveryAddressName,
          delivery_address_1: delivery_address.line_1,
          delivery_address_2: delivery_address.line_2,
          delivery_address_3: delivery_address.line_3,
          delivery_address_4: delivery_address.line_4,
          delivery_address_5: delivery_address.line_5,
          delivery_postcode: delivery_address.postcode,
        }
      : {
          delivery_name: deliveryAddressName,
          delivery_address_1: delivery_address.line1,
          delivery_address_2: delivery_address.line2,
          delivery_address_3: delivery_address.line3,
          delivery_address_4: delivery_address.line4,
          delivery_address_5: delivery_address.line5,
          delivery_postcode: delivery_address.postcode,
        };
    $.ajax({
      url: this.props.urls.delivery_address,
      method: 'PUT',
      dataType: 'json',
      data: {
        delivery_name: formatted_address.delivery_name,
        delivery_address1: formatted_address.delivery_address_1,
        delivery_address2: formatted_address.delivery_address_2,
        delivery_address3: formatted_address.delivery_address_3,
        delivery_address4: formatted_address.delivery_address_4,
        delivery_address5: formatted_address.delivery_address_5,
        delivery_postcode: formatted_address.delivery_postcode,
      },
      success: () => {
        this.setState({
          selected_delivery_address: {
            name: formatted_address.delivery_name,
            line1: formatted_address.delivery_address_1,
            line2: formatted_address.delivery_address_2,
            line3: formatted_address.delivery_address_3,
            line4: formatted_address.delivery_address_4,
            line5: formatted_address.delivery_address_5,
            postcode: formatted_address.delivery_postcode,
          },
        });
        // Get new delivery options for updated delivery Address
        this.getDeliveryOptionsForBasket();
        this.setInvoiceAddress(delivery_address);
      },
      error: ({ responseText }) => {
        this.setState({
          loading: false,
          loading_message: '',
        });

        const title = responseText
          ? JSON.parse(responseText).message
          : 'Unfortunately something has gone wrong.';
        const message = responseText
          ? 'We are sorry for any inconvenience this may cause.'
          : 'We are sorry for any inconvenience this may cause. Please try again later. If the problem persists, please contact our customer service team.';

        this.configGenericError({
          title: 'Something has gone wrong',
          body: (
            <div>
              <p>{title}</p>
              <p>{message}</p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: 'Refresh Checkout',
          errorButtonAction: this.toggleGenericError,
          closeAction: this.toggleGenericError,
          reloadCheckoutAfterClose: true,
          reloadCheckoutAfterErrorButtonAction: true,
        });
      },
    });
  }
  pushBillingAddress(formatted_address) {
    $.ajax({
      url: this.props.urls.billing_address,
      method: 'PUT',
      dataType: 'json',
      data: {
        billing_name: formatted_address.billing_name,
        billing_address_1: formatted_address.billing_address_1,
        billing_address_2: formatted_address.billing_address_2,
        billing_address_3: formatted_address.billing_address_3,
        billing_address_4: formatted_address.billing_address_4,
        billing_address_5: formatted_address.billing_address_5,
        billing_postcode: formatted_address.billing_postcode,
      },
      success: () => {
        this.setState({
          loading: false,
          loading_message: '',
          selected_billing_address: {
            name: formatted_address.billing_name,
            line1: formatted_address.billing_address_1,
            line2: formatted_address.billing_address_2,
            line3: formatted_address.billing_address_3,
            line4: formatted_address.billing_address_4,
            line5: formatted_address.billing_address_5,
            postcode: formatted_address.billing_postcode,
          },
        });
      },
      error: ({ responseText }) => {
        this.setState({
          loading: false,
          loading_message: '',
        });

        const title = responseText
          ? JSON.parse(responseText).message
          : 'Unfortunately something has gone wrong.';
        const message = responseText
          ? 'We are sorry for any inconvenience this may cause.'
          : 'We are sorry for any inconvenience this may cause. Please try again later. If the problem persists, please contact our customer service team.';

        this.configGenericError({
          title: 'Something has gone wrong',
          body: (
            <div>
              <p>{title}</p>
              <p>{message}</p>
            </div>
          ),
          errorButton: true,
          errorButtonTitle: 'Refresh Checkout',
          errorButtonAction: this.toggleGenericError,
          closeAction: this.toggleGenericError,
          reloadCheckoutAfterClose: true,
          reloadCheckoutAfterErrorButtonAction: true,
        });
      },
    });
  }

  setInvoiceAddress(billing_address) {
    const guestName =
      this.state.address_mode === 'BRANCH_DELIVERY'
        ? billing_address.name
        : this.props.misc.name;
    const billingAddressName = this.props.signed_in
      ? billing_address.name
      : guestName;

    let formatted_address = billing_address.hasOwnProperty('line_1')
      ? {
          billing_name: billingAddressName,
          billing_address_1: billing_address.line_1,
          billing_address_2: billing_address.line_2,
          billing_address_3: billing_address.line_3,
          billing_address_4: billing_address.line_4,
          billing_address_5: billing_address.line_5,
          billing_postcode: billing_address.postcode,
        }
      : {
          billing_name: billingAddressName,
          billing_address_1: billing_address.line1,
          billing_address_2: billing_address.line2,
          billing_address_3: billing_address.line3,
          billing_address_4: billing_address.line4,
          billing_address_5: billing_address.line5,
          billing_postcode: billing_address.postcode,
        };
    if (this.state.current_step === 'PAYMENT') {
      this.setState(
        {
          loading: true,
          loading_message: 'Setting your billing address',
        },
        () => {
          this.pushBillingAddress(formatted_address);
        },
      );
    } else {
      this.pushBillingAddress(formatted_address);
    }
  }

  completeCollectionOnlyOrder(collection_information, collection_confirmed) {
    var email_regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Expand the validation
    if (
      collection_confirmed == true &&
      email_regex.test(collection_information.email)
    ) {
      this.setState({
        processing_order: true,
      });

      $.ajax({
        url: this.props.urls.complete_order,
        dataType: 'json',
        method: 'post',
        data: {
          collection_confirmed: collection_confirmed,
          collection_information: collection_information,
        },
        success: data => {
          this.setState({
            processing_order: false,
          });
          this.setState({
            order_complete: data.complete,
            order_complete_url: data.complete_order_url,
          });
          this.showDetailErrors(false);
        },
        error: data => {
          this.showDetailErrors(true, data.responseText);
          this.setLoadingState(false);
          this.setState({
            processing_order: false,
          });
        },
      });
    }
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  showDetailErrors(show_display_error, display_errors) {
    this.setState({
      show_display_error: !show_display_error ? false : show_display_error,
      display_errors: !show_display_error
        ? []
        : JSON.parse(display_errors).errors,
    });
  }

  render() {
    const {
      account_details: { order_approvals_required: orderApprovalsEnabled },
    } = this.props;

    if (this.state.order_complete !== true) {
      let delivery = '';
      let collection = '';
      let deliveryDetails = '';
      let payment = '';
      let checkoutModal = '';
      let loading = '';

      if (this.state.loading) {
        loading = (
          <div className="checkout-modal">
            <div className="modal-content">
              <div className="loader">Processing..</div>
            </div>
          </div>
        );
      }

      if (this.state.processing_order === true) {
        checkoutModal = <CheckoutModal title={''} message={''} loader={true} />;
      } else if (this.state.order_complete === true) {
        let title =
          this.state.basket_summary.type === 'COLLECTION'
            ? 'Collection Processed'
            : 'Order Complete';
        let message =
          this.state.basket_summary.type === 'COLLECTION'
            ? 'Please wait for an email before collecting your order.'
            : 'Order Complete';
        checkoutModal = (
          <CheckoutModal
            title={title}
            message={message}
            loader={false}
            url={this.state.order_complete_url}
            urlText={'View your collection here'}
            success={true}
          />
        );
      }

      if (this.props.basket_summary.collection_basket === true) {
        collection = (
          <Collection
            step={'1'}
            collectionAddress={this.state.collection_address}
            completeCollectionOnlyOrder={this.completeCollectionOnlyOrder}
            orderType={this.props.basket_summary.type}
            accountDetails={this.props.account_details}
            current_step={this.state.current_step}
            setCurrentStep={this.setCurrentStep}
            getSummary={this.getBasketSummary}
            collectionUrl={this.props.urls.collection_details}
            setLoadingState={this.setLoadingState}
            processingState={this.state.processing_payment}
            basket_type={this.props.basket_type}
            signed_in={this.props.signed_in}
            show_display_error={this.state.show_display_error}
            display_errors={this.state.display_errors}
            showDetailErrors={this.showDetailErrors}
            guestTelephone={this.state.guestTelephone}
            accountTelephone={this.state.accountTelephone}
          />
        );
      } else {
        deliveryDetails = (
          <DeliveryDetails
            step={'2'}
            delivery_options={this.state.delivery_options}
            purchaseOrderRequired={
              this.props.basket_summary.purchase_order_required
            }
            current_step={this.state.current_step}
            setCurrentStep={this.setCurrentStep}
            nextStep={'COLLECTION_DETAILS'}
            nextStepText="Collection Details"
            setDeliveryDetailsUrl={this.props.urls.set_delivery_details}
            validatePurchaseOrderMaskUrl={
              this.props.urls.validate_purchase_order_mask
            }
            setLoadingState={this.setLoadingState}
            getSummary={this.getBasketSummary}
            clearDeliveryService={this.clearDeliveryService}
            processingState={this.state.processing_payment}
            signed_in={this.props.signed_in}
            setDeliveryAddress={this.setDeliveryAddress}
            email={this.props.account_details.email}
            guestTelephone={this.state.guestTelephone}
            accountTelephone={this.state.accountTelephone}
            show_display_error={this.state.show_display_error}
            display_errors={this.state.display_errors}
            showDetailErrors={this.showDetailErrors}
            configGenericError={this.configGenericError}
            genericErrorConfig={this.state.generic_error}
            toggleGenericError={this.toggleGenericError}
            basketHasBackOrderItems={this.state.basketHasBackOrderItems}
            warningIcon={this.props.assets.misc.warningIcon}
            deliveryMessaging={this.state.messaging.delivery_options}
          />
        );
        payment = (
          <Payment
            step={'4'}
            current_step={this.state.current_step}
            delivery_address={this.state.selected_delivery_address}
            invoice_address={this.state.selected_billing_address}
            customerInvoiceAddress={this.props.account_details.invoice_address}
            setInvoiceAddress={this.setInvoiceAddress}
            addressBook={this.state.address_book}
            addressMode={this.state.address_mode}
            setAddressFromAddressBook={this.setAddressFromAddressBook}
            setInvoiceAddressFromAddressBook={
              this.setInvoiceAddressFromAddressBook
            }
            setInvoiceAddressAsDeliveryAddress={
              this.setInvoiceAddressAsDeliveryAddress
            }
            cashOnly={this.props.cash_only}
            setAddressMode={this.setAddressMode}
            addressEnquiryUrl={this.props.urls.address_enquiry}
            deliveryAddressUrl={this.props.urls.delivery_address}
            billingAddressUrl={this.props.urls.billing_address}
            getAddressBook={this.getAddressBook}
            getSummary={this.getBasketSummary}
            summary={this.state.basket_summary}
            completeAccountOrderUrl={this.props.urls.complete_account_order}
            completeOrder={this.completeOrder}
            itsPaymentUrl={this.props.urls.its_payment_url}
            paypalPaymentUrl={this.props.urls.paypal_payment_url}
            paymentTotal={
              this.state.basket_summary.total_delivery_items_with_carriage
            }
            assets={this.props.assets}
            setPaymentStatus={this.setProcessingPayment}
            processingState={this.state.processing_payment}
            configGenericError={this.configGenericError}
            genericErrorConfig={this.state.generic_error}
            signed_in={this.props.signed_in}
            email={this.props.misc.email}
            name={this.props.misc.name}
            showDetailErrors={this.showDetailErrors}
            branchAddressFlag={this.state.branchAddressFlag}
            guestTelephone={this.state.guestTelephone}
            accountTelephone={this.state.accountTelephone}
            toggleGenericError={this.toggleGenericError}
            paymentOpen={this.state.paymentOpen}
            orderApprovalsEnabled={orderApprovalsEnabled}
            paymentOptions={this.state.paymentOptions}
            message={this.state.messaging.payment_options}
          />
        );
        delivery = (
          <DeliveryAddress
            step={'1'}
            branchAddress={this.props.account_details.branch_address}
            addressBook={this.state.address_book}
            branches={this.state.branches}
            showBranchPanel={this.state.showBranchPanel}
            addressMode={this.state.address_mode}
            invoiceAddress={this.props.account_details.invoice_address}
            account={this.props.account_details}
            setAddressMode={this.setAddressMode}
            selectedDeliveryAddress={this.state.selected_delivery_address}
            setAddressFromAddressBook={this.setAddressFromAddressBook}
            current_step={this.state.current_step}
            setCurrentStep={this.setCurrentStep}
            setInvoiceAddressAsDeliveryAddress={
              this.setInvoiceAddressAsDeliveryAddress
            }
            getSummary={this.getBasketSummary}
            clearDeliveryService={this.clearDeliveryService}
            addressEnquiryUrl={this.props.urls.address_enquiry}
            deliveryAddressUrl={this.props.urls.delivery_address}
            getAddressBook={this.getAddressBook}
            getBranches={this.getBranches}
            showNoBranches={this.state.showNoBranches}
            processingState={this.state.processing_payment}
            signed_in={this.props.signed_in}
            name={this.props.misc.name}
            setDeliveryAddress={this.setDeliveryAddress}
            setGuestTelephone={this.setGuestTelephone}
            configGenericError={this.configGenericError}
            genericErrorConfig={this.state.generic_error}
            toggleGenericError={this.toggleGenericError}
            guestEmail={this.props.account_details.email}
            guestTelephone={this.state.guestTelephone}
            setBranchAddressFlag={this.setBranchAddressFlag}
          />
        );
        if (this.props.basket_summary.collection_lines === true) {
          collection = (
            <Collection
              step={'3'}
              collectionAddress={this.state.collection_address}
              accountDetails={this.props.account_details}
              orderType={this.props.basket_summary.type}
              current_step={this.state.current_step}
              setCurrentStep={this.setCurrentStep}
              getSummary={this.getBasketSummary}
              collectionUrl={this.props.urls.collection_details}
              setLoadingState={this.setLoadingState}
              processingState={this.state.processing_payment}
              signed_in={this.props.signed_in}
              show_display_error={this.state.show_display_error}
              display_errors={this.state.display_errors}
              showDetailErrors={this.showDetailErrors}
              guestTelephone={this.state.guestTelephone}
              accountTelephone={this.state.accountTelephone}
            />
          );
        } else {
          collection = '';
          deliveryDetails = (
            <DeliveryDetails
              step={'2'}
              delivery_options={this.state.delivery_options}
              purchaseOrderRequired={
                this.props.basket_summary.purchase_order_required
              }
              current_step={this.state.current_step}
              setCurrentStep={this.setCurrentStep}
              nextStep={'PAYMENT'}
              nextStepText={'Payment'}
              setDeliveryDetailsUrl={this.props.urls.set_delivery_details}
              validatePurchaseOrderMaskUrl={
                this.props.urls.validate_purchase_order_mask
              }
              setLoadingState={this.setLoadingState}
              getSummary={this.getBasketSummary}
              clearDeliveryService={this.clearDeliveryService}
              processingState={this.state.processing_payment}
              signed_in={this.props.signed_in}
              setDeliveryAddress={this.setDeliveryAddress}
              email={this.props.account_details.email}
              guestTelephone={this.state.guestTelephone}
              accountTelephone={this.state.accountTelephone}
              show_display_error={this.state.show_display_error}
              display_errors={this.state.display_errors}
              showDetailErrors={this.showDetailErrors}
              configGenericError={this.configGenericError}
              genericErrorConfig={this.state.generic_error}
              toggleGenericError={this.toggleGenericError}
              basketHasBackOrderItems={this.state.basketHasBackOrderItems}
              warningIcon={this.props.assets.misc.warningIcon}
              deliveryMessaging={this.state.messaging.delivery_options}
            />
          );
          payment = (
            <Payment
              step={'3'}
              current_step={this.state.current_step}
              delivery_address={this.state.selected_delivery_address}
              invoice_address={this.state.selected_billing_address}
              customerInvoiceAddress={
                this.props.account_details.invoice_address
              }
              setInvoiceAddress={this.setInvoiceAddress}
              addressBook={this.state.address_book}
              addressMode={this.state.address_mode}
              cashOnly={this.props.cash_only}
              setAddressFromAddressBook={this.setAddressFromAddressBook}
              setInvoiceAddressFromAddressBook={
                this.setInvoiceAddressFromAddressBook
              }
              setInvoiceAddressAsDeliveryAddress={
                this.setInvoiceAddressAsDeliveryAddress
              }
              setAddressMode={this.setAddressMode}
              addressEnquiryUrl={this.props.urls.address_enquiry}
              deliveryAddressUrl={this.props.urls.delivery_address}
              billingAddressUrl={this.props.urls.billing_address}
              getAddressBook={this.getAddressBook}
              getSummary={this.getBasketSummary}
              summary={this.state.basket_summary}
              completeAccountOrderUrl={this.props.urls.complete_account_order}
              completeOrder={this.completeOrder}
              itsPaymentUrl={this.props.urls.its_payment_url}
              paypalPaymentUrl={this.props.urls.paypal_payment_url}
              paymentTotal={
                this.state.basket_summary.total_delivery_items_with_carriage
              }
              assets={this.props.assets}
              setPaymentStatus={this.setProcessingPayment}
              processingState={this.state.processing_payment}
              configGenericError={this.configGenericError}
              genericErrorConfig={this.state.generic_error}
              signed_in={this.props.signed_in}
              name={this.props.misc.name}
              email={this.props.misc.email}
              show_display_error={this.state.show_display_error}
              display_errors={this.state.display_errors}
              showDetailErrors={this.showDetailErrors}
              branchAddressFlag={this.state.branchAddressFlag}
              guestTelephone={this.state.guestTelephone}
              accountTelephone={this.state.accountTelephone}
              toggleGenericError={this.toggleGenericError}
              paymentOpen={this.state.paymentOpen}
              orderApprovalsEnabled={orderApprovalsEnabled}
              paymentOptions={this.state.paymentOptions}
              message={this.state.messaging.payment_options}
            />
          );
        }
      }
      return (
        <div>
          <div className="container checkout--header">
            <div className="row-fluid">
              <div className="span8">
                <div className="row-fluid title">
                  <div className="span6">
                    <h1>Checkout</h1>
                  </div>
                  <div className="span6">
                    <div className="secure-icons">
                      <span>
                        <div className="padlock-icon" />
                        Secure Payment
                      </span>
                      <img
                        alt="Secure_global_sign"
                        src={this.props.assets.misc.secure}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container single-page-checkout">
            {this.state.generic_error.active === true ? (
              <GenericError config={this.state.generic_error} />
            ) : (
              ''
            )}
            {loading}
            {checkoutModal}

            <OrderSummary
              summary={this.state.basket_summary}
              orderType={this.state.basket_summary.type}
              deliveryAddress={this.state.selected_delivery_address}
              collectionAddress={this.state.collection_address}
              voucherUrl={this.props.urls.vouchers}
              voucherApplied={this.state.basket_summary.voucher_applied}
              voucherSavings={this.state.basket_summary.voucher_savings}
              getSummary={this.getBasketSummary}
              progress={this.state.progress}
              currentStep={this.state.current_step}
              processingState={this.state.processing_payment}
              assets={this.props.assets}
              signed_in={this.props.signed_in}
              orderApprovalsEnabled={orderApprovalsEnabled}
            />
            <div className="checkout-pannels">
              {delivery}
              {deliveryDetails}
              {collection}
              {payment}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <OrderComplete
          orderDetails={this.state.order_complete_summary}
          orderCompleteUrl={this.state.order_complete_url}
          assets={this.props.assets}
        />
      );
    }
  }
}

Checkout.propTypes = {
  urls: PropTypes.object,
  steps: PropTypes.array,
  loading: PropTypes.bool,
  loading_message: PropTypes.string,
};

export default Checkout;
